import { types } from '../constants'

const index = {
  pending: `${types.listTransaction}_PENDING`,
  fulfilled: `${types.listTransaction}_FULFILLED`,
  rejected: `${types.listTransaction}_REJECTED`,
  setPage: types.listTransactionSetPage,
  setPerPage: types.listTransactionSetPerPage
}

export const listTransaction = {
  [index.pending]: ({ draft }) => {
    draft.industry.wallet.listTransaction.loading = true
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.industry.wallet.listTransaction.data = action.payload.data

    draft.industry.wallet.listTransaction.pages = action.payload.pages
    draft.industry.wallet.listTransaction.total = action.payload.total
    draft.industry.wallet.listTransaction.page = action.payload.page

    draft.industry.wallet.listTransaction.loading = false
    draft.industry.wallet.listTransaction.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.industry.wallet.listTransaction.loading = false
    draft.industry.wallet.listTransaction.error = action.payload
    draft.industry.wallet.listTransaction.total = 0
    draft.industry.wallet.listTransaction.data = null
  },
  [index.setPage]: ({ draft, action }) => {
    draft.industry.wallet.listTransaction.page = action.payload
  },
  [index.setPerPage]: ({ draft, action }) => {
    draft.industry.wallet.listTransaction.perPage = action.payload
  }
}
